import React from 'react';
import { Skill } from '../../../../../types/resume';
import SkillItem from './SkillItem';

interface Props {
  skills: Skill[];
  onUpdate: (skills: Skill[]) => void;
}

export default function SkillsList({ skills, onUpdate }: Props) {
  const updateSkill = (id: string, updates: Partial<Skill>) => {
    const updated = skills.map(skill => 
      skill.id === id ? { ...skill, ...updates } : skill
    );
    onUpdate(updated);
  };

  const removeSkill = (id: string) => {
    onUpdate(skills.filter(skill => skill.id !== id));
  };

  return (
    <div className="space-y-3">
      {skills.length === 0 ? (
        <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
          <p className="text-gray-500">No skills added yet</p>
          <p className="text-sm text-gray-400">Add skills to showcase your expertise</p>
        </div>
      ) : (
        <div className="space-y-3">
          {skills.map((skill) => (
            <SkillItem
              key={skill.id}
              skill={skill}
              onUpdate={updateSkill}
              onRemove={removeSkill}
            />
          ))}
        </div>
      )}
    </div>
  );
}